import React, { useEffect, useState } from 'react'
import './EmploymentInfo.scss'
import profileService from 'Services/profileService'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { ModalWrapper } from 'Components'
import Briefcase from 'Assets/Images/brief-case-3.png'
import EmploymentUpdate from './Modals/EmploymentUpdate/EmploymentUpdate'
import { EmployeeSingleType } from 'Models/employeeType'

type formType = {
  jobTitle: string | null
  department: string | null
  employmentType: string | null
  manager: string | null
  employeeId: string | null
  workLocation: string | null
  employmentDate: string | null
  terminationDate: string | null
  deactivationDate: string | null
}

export type profileUpdateType2 = {
  jobTitle: string
  department: string
  lineManagerId: string
  workLocation: string
  employmentType: string
  employmentDate: string
}

type Props = {
  profile: any
  setProfile: any
}

const EmploymentInfo = ({ profile, setProfile }: Props) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<formType>({
    defaultValues: {
      jobTitle: profile?.jobTitle,
      department: profile?.department,
      employmentType: profile?.employmentType,
      manager: profile?.manager,
      employeeId: profile?.employeeId,
      workLocation: profile?.workLocation,
      employmentDate: profile?.employmentDate,
      terminationDate: profile?.terminationDate,
      deactivationDate: profile?.deactivationDate,
    },
  })

  const {
    handleSubmit: handleSubmit2,
    register: register2,
    setValue: setValue2,
    formState: { errors: errors2 },
  } = useForm<EmployeeSingleType>()

  // Update form values when the profile data changes
  useEffect(() => {
    if (profile) {
      setValue2('jobTitle', profile?.jobTitle)
      setValue2('department', profile?.department)
      setValue2('manager', profile?.manager)
      setValue2('employeeId', profile?.employeeDisplayId)
      setValue2('employmentDate', profile?.employmentDate)
      setValue2('workLocation', profile?.workLocation?.trim())
      setValue2('employmentType', profile?.employmentType)
      setValue2('employmentStatus', profile?.employmentStatus)
      // setValue2("lineManagerId", profile?.manager);
    }
  }, [profile, setValue])

  const submitEmployeeDeatils = async (data: profileUpdateType2): Promise<boolean> => {
    // setRequest2(true)

    try {
      const res = await profileService.adminUpdateUserProfile(profile?.id, {
        jobTitle: data.jobTitle,
        department: data.department,
        lineManagerId: data.lineManagerId,
        workLocation: data.workLocation,
        employmentType: data.employmentType,
        employmentDate: data.employmentDate,
        // lineManagerId: data.lineManagerId,
      })

      if (res.data.status === true) {
        Swal.fire({
          text: `${profile?.firstName} employment information updated succesfully`,
          icon: 'success',
          confirmButtonText: 'Ok',
        })

        setProfile((prev: any) => ({
          ...prev,
          ...data,
        }))

        return true
      } else {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })

        swalWithBootstrapButtons.fire({
          title: 'Oops!',
          text: 'Something went wrong!',
          icon: 'warning',
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: 'close',
          reverseButtons: true,
        })
        return false
      }
    } catch (error: any) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })

      swalWithBootstrapButtons.fire({
        title: 'Oops!',
        text: error.response.data.error,
        icon: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'close',
        reverseButtons: true,
      })
      return false
    }
  }

  const [showModal, setShowModal] = useState(false)
  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }

  const [users, setUsers] = useState([])

  const getAllUsers = async () => {
    try {
      const res = await profileService.getAllProfile('1')
      // console.log(res)
      if (res.data.status === true) {
        setUsers(res.data.data?.dataset)
      } else {
        setUsers([])
      }
    } catch (error: any) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })

      swalWithBootstrapButtons.fire({
        title: 'Oops!',
        text: error.response.data.error,
        icon: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'close',
        reverseButtons: true,
      })
    }
  }

  useEffect(() => {
    getAllUsers()
  }, [])

  return (
    <div className='employment-info'>
      {/* <form onSubmit={submitEmployeeDeatils}> */}
      <div className='container-fluid m-0 p-0'>
        <div className='row g-4'>
          <div className='col-lg-7'>
            <div className='card'>
              <div className='card-header d-flex justify-content-between'>
                <span> Job & Organization</span>
              </div>
              <div className='card-body'>
                <div className='job-con-wrapper'>
                  <div>
                    <div className='job-con'>
                      <img src={Briefcase} alt='icon' /> <span>Job Title</span>
                    </div>
                    <div className='form-group'>
                      <input
                        disabled
                        autoComplete='off'
                        type='text'
                        id='job_title'
                        className={`form-control ${errors2.jobTitle ? 'is-invalid' : ''}`}
                        {...register2('jobTitle', {
                          required: 'Job title is required',
                        })}
                      />
                      {errors2.jobTitle && (
                        <div className='invalid-feedback'>{errors2.jobTitle.message}</div>
                      )}
                    </div>
                  </div>

                  <div className='ms-auto'>
                    <button
                      onClick={toggleModal}
                      type='button'
                      className='reset-btn-as-link btn-default-2-alt'
                    >
                      Update
                    </button>
                  </div>
                </div>

                {/* Department */}
                <div className='form-group mt-5'>
                  <div className='formLine'>
                    <label htmlFor='department' className='mb-0'>
                      Department
                    </label>

                    <select
                      disabled
                      autoComplete='off'
                      id='department'
                      className={`form-control custom-select ${errors2.department ? 'is-invalid' : ''}`}
                      {...register2('department', {
                        required: 'Department is required',
                      })}
                    >
                      <option value=''>Select</option>
                      <option>Finance Department</option>
                      <option>Legal Department</option>
                      <option>Corporate Communications Department</option>
                      <option>Sales/Marketing Department</option>
                      <option>Product Operations Department</option>
                      <option>Product Engineering Department</option>
                      <option>Human Resources Department</option>
                    </select>
                  </div>

                  {errors2.department && (
                    <div className='invalid-feedback d-block'>{errors2.department.message}</div>
                  )}
                </div>

                <div className='form-group form-up'>
                  <div className='formLine'>
                    <label htmlFor='manager' className='mb-0'>
                      Manager <span className='d-none d-md-inline'> / Supervisor</span>
                    </label>

                    <input
                      disabled
                      autoComplete='off'
                      type='text'
                      id='manager'
                      className={`form-control custom-select ${errors2.manager ? 'is-invalid' : ''}`}
                      {...register2('manager', {
                        required: 'Manager/Supervisor is required',
                      })}
                    />

                    {errors2.manager && (
                      <div className='invalid-feedback'>{errors2.manager.message}</div>
                    )}
                  </div>
                </div>

                <div className='form-group form-u mb-2'>
                  <div className='formLine'>
                    <label htmlFor='department' className='mb-0 text-nowrap'>
                      Work Location
                    </label>

                    <div
                      className={`form-control custom-display this-only ${
                        errors2.workLocation ? 'is-invalid' : ''
                      }`}
                      title={profile?.workLocation}
                    >
                      {profile?.workLocation}
                    </div>

                    {errors2.workLocation && (
                      <div className='invalid-feedback'>{errors2.workLocation.message}</div>
                    )}
                  </div>
                </div>

                <div className='form-group form-up'>
                  <div className='formLine'>
                    <label htmlFor='employmentType' className='mb-0'>
                      Employment Type
                    </label>

                    <select
                      disabled
                      autoComplete='off'
                      id='employmentType'
                      className={`form-control custom-select ${errors2.employmentType ? 'is-invalid' : ''}`}
                      {...register2('employmentType', {
                        required: 'field is required',
                      })}
                    >
                      <option value=''>Select</option>
                      <option>Full-time</option>
                      <option>Part-time</option>
                      <option>Contract</option>
                    </select>
                    {errors2.employmentType && (
                      <div className='invalid-feedback'>{errors2.employmentType.message}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-5'>
            <div className='card'>
              <div className='card-body'>
                <div className='form-group form-up'>
                  <div className='formLine'>
                    <label htmlFor='employmentStatus'>Employment Status</label>

                    <div className='active-con d-flex align-items-center gap-1'>
                      <div className='active-dot'></div>
                      <div className='status'>{profile?.employmentStatus}</div>
                    </div>
                  </div>
                </div>

                <div className='form-group form-u'>
                  <div className='formLine'>
                    <label className='text-nowrap' htmlFor='employeeId'>
                      Employee ID
                    </label>

                    <input
                      autoComplete='off'
                      type='text'
                      id='employeeId'
                      disabled
                      className={`form-control custom-select ${errors2.employeeId ? 'is-invalid' : ''}`}
                      {...register2('employeeId')}
                    />
                    {errors2.employeeId && (
                      <div className='invalid-feedback'>{errors2.employeeId.message}</div>
                    )}
                  </div>
                </div>

                {/* Employment Start Date */}
                <div className='form-group pb-2'>
                  <div className='formLine'>
                    <label htmlFor='employment_start_date'>Employment Start Date</label>

                    <span className='custom-select'>{profile?.employmentDate}</span>

                    {errors2.employmentDate && (
                      <div className='invalid-feedback'>{errors2.employmentDate.message}</div>
                    )}
                  </div>
                </div>

                <div className='form-group form-down d-none'>
                  <div className='formLine'>
                    <label htmlFor='employment_start_date'>Date of Joining</label>

                    <span className='custom-select'>{profile?.employmentDate}</span>

                    {errors2.employmentDate && (
                      <div className='invalid-feedback'>{errors2.employmentDate.message}</div>
                    )}
                  </div>
                </div>

                <div className='form-group form-down d-none'>
                  <div className='formLine'>
                    <label htmlFor='employment_start_date'>Confirmation Date</label>

                    <span className='custom-select'>{profile?.employmentDate}</span>

                    {errors2.employmentDate && (
                      <div className='invalid-feedback'>{errors2.employmentDate.message}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className='form-group col-12 col-md-6 mt-3'>
            <label htmlFor='lineManagerId'>Line Manager</label>
            <select autoComplete='off' id='lineManagerId' className='form-control' disabled>
              {employees &&
                employees.map(
                  (item, index: Key) =>
                    item.id === profile?.lineManagerId && (
                      <option
                        key={index}
                        value={item.id}
                        selected={item.id === profile?.lineManagerId}
                      >
                        {item.firstName} {item.lastName}
                      </option>
                    ),
                )}
            </select>
          </div> */}
      </div>
      {/* </form> */}

      <ModalWrapper
        showModal={showModal}
        closeModal={toggleModal}
        title={<span className='custom-modal-title'> Update Job Details</span>}
      >
        <EmploymentUpdate
          toggleModal={toggleModal}
          profile={profile}
          onSave={submitEmployeeDeatils}
          users={users}
        ></EmploymentUpdate>
      </ModalWrapper>
    </div>
  )
}

export default EmploymentInfo
